import React, { ReactElement } from 'react';
import { useMutation } from '@apollo/client';
import { Modal } from '@odin-labs/components';
import {
  GetWorkerCardsDocument,
  MutationRemoveCardFromWorkerArgs,
  Success,
} from 'apollo/generated/client-operations';
import { getGraphQLError } from 'utils/error';
import { MinusOctagonIcon } from 'components/icons';
import { AlertService } from 'components/alertService';
import { REMOVE_CARD_FROM_WORKER } from 'containers/worker/helpers/queries';
import { DeactivateBadgeModalProps } from './types';

export function DeactivateBadgeModal(
  props: DeactivateBadgeModalProps,
): ReactElement {
  const { isOpen, workerCardId, closeModal, onConfirm } = props;

  const [removeCardFromWorker, { loading }] = useMutation<
    Success,
    MutationRemoveCardFromWorkerArgs
  >(REMOVE_CARD_FROM_WORKER, {
    onCompleted: () => {
      onConfirm();
      AlertService.alert('success', 'Success!', '');
    },
    onError: (error) => {
      AlertService.alert(
        'danger',
        'Something went wrong!',
        getGraphQLError(error),
      );
    },
    variables: { workerCardIds: [workerCardId] },
    refetchQueries: [GetWorkerCardsDocument],
  });

  return (
    <Modal
      open={isOpen}
      setOpen={closeModal}
      size="xs"
      title="Deactivate badge"
      titleAlignment="center"
      text="Would you like to deactivate this badge?"
      textAlignment="center"
      onAction={removeCardFromWorker}
      actionText="Deactivate"
      actionButtonTheme="danger"
      actionIcon={MinusOctagonIcon}
      actionButtonWithSpinner={loading}
    />
  );
}
